import { isBroswer } from '@/utils';
import { armsErrorSend } from '@/utils/libs/armsErrorSend';

function isJSONObject(data: unknown): data is object {
  return !!data && typeof data === 'object' && !Array.isArray(data);
}

/**
 * 接口API发送埋点事件（内部做了降级处理方案），可以保证页面跳转时埋点的发送成功率
 * 封装使用navigator.sendBeacon 方法
 * @param url
 * @param {Object} data 只支持JSON格式的
 */
export function sendBeacon({ url, data }: { url: string; data: object }): Promise<boolean> {
  return new Promise((resolve) => {
    if (!isBroswer || !isJSONObject(data)) return resolve(false);
    let payload;

    try {
      // 处理发送数据（自动序列化 JSON）
      const _data = JSON.stringify(data);
      payload = new Blob([_data], { type: 'application/json' });

      const res = navigator.sendBeacon(url, payload);
      // 如果sendBeacon失败，降级到keep-alive方案
      if (!res) return requestKeepAlive(url, data);
      resolve(true);
    } catch (error) {
      armsErrorSend(error as Error, { filename: 'sendBeacon error', data: { url, data } });
      requestKeepAlive(url, data);
      resolve(false);
    }
  });
}

/**
 * 接口API发送埋点事件，可以保证页面跳转时埋点的发送成功率，在sendBeacon无法使用时作为备选处理方案。
 * @param url
 * @param {Object} data 只支持JSON格式的
 *
 * @example
 * requestKeepAlive('/api', {xx:xx});
 */
function requestKeepAlive(url: string, data: object) {
  if (!isBroswer || !isJSONObject(data)) return;
  try {
    const body: BodyInit = JSON.stringify(data);

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
      credentials: 'omit',
      keepalive: true,
    }).catch((error) => {
      armsErrorSend(error as Error, { filename: 'keepAliveReques fetch error', data: { url, data } });
    });
  } catch (error) {
    armsErrorSend(error as Error, { filename: 'keepAliveReques error', data: { url, data } });
    return;
  }
}
